module.exports = __webpack_public_path__ + "static/media/Bodoni-FLF.82cff29b.svg";